/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export const isValidEmail = (email: string) => {
  if (Number(email) < 0) return false;

  return email?.length === 0 ? true : !!email.match(emailPattern);
};
